import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "revico-community-talk-talkroom-more-button-wrapper"
}
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" トークルームもっと見るボタン "),
    ($setup.isShow())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            class: "revico-community-talk-talkroom-more-button",
            onClick: $setup.onclick,
            disabled: $props.isProcessingAddTalkRoom
          }, _toDisplayString($props.moreButtonDisplayName), 9 /* TEXT, PROPS */, _hoisted_2)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}